import context  from './store/context';
import Platform from './platform';

export {
  context,
  Platform,
};
